export default "__VITE_PUBLIC_ASSET__75dbd267__"